export const styleType = {
  UNDEFINED: 'UNDEFINED',
  INFORMATION: 'INFORMATION',
  OFFERTA: 'OFFERTA',
  SOPDBANK: 'SOPDBANK',
  SOPDUPT: 'SOPDUPT',
}

export const styleTypeTitle = {
  [styleType.UNDEFINED]: 'UNDEFINED',
  [styleType.INFORMATION]: 'Информация',
  [styleType.OFFERTA]: 'Оферта',
  [styleType.SOPDBANK]: 'СОПД "БАНК"',
  [styleType.SOPDUPT]: 'СОПД "ООО УПТ"',
}

export const styleTypeOptions = Object.values(styleType).map((item) => ({
  label: styleTypeTitle[item],
  value: item,
}))

export const DOCUMENT_LOCALIZATION = ['RU', 'EN', 'HY']
